//请自行添加语言资源
const orderSignLog = {
  serialNo: '流水号',
  orderNo: '客户订单号',
  signDate: '签收日期',
  signStatusName: '签收状态',
  remark: '签收备注',
  dealStatusName: '处理状态',
  dealCount: '处理次数',
  dealTime: '处理时间',
  dealResult: '处理结果',
  createTime: '创建时间',
  detail: {
    itemNo: '行号',
    skuCode: '产品编码',
    skuDesc: '产品描述',
    batch: '产品批次',
    signQty: '实际签收数量',
    rejectQty: '异常签收-拒收数量',
    rejectReasonNoName: '异常签收-拒收原因',
  },
  msg: {}
};
export default orderSignLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderSignLog/lang/orderSignLog.zh.js